// https://developers.holded.com/reference/list-documents-1

import Holded from "../../../../assets/WhiteHoldedCircle.svg";

export const json = [
  {
    endpoint: "url1/url2",
    method: "POST",
    name: "HoldedPost",
    description: "4free",
    type: "Holded",
    image: Holded,
    data: [
      {
        type: "type 1",
        required: true,
        description: "Description Variable 1",
        title: "Title Variable 1",
      },
      {
        type: "type 2",
        required: true,
        description: "Description Variable 2",
        title: "Title Variable 2",
      },
      {
        type: "type 3",
        required: true,
        description: "Description Variable 3",
        title: "Title Variable 3",
      },
      {
        type: "type 4",
        required: true,
        description: "Description Variable 4",
        title: "Title Variable 4",
      },
    ],
  },
  {
    endpoint: "url1/url2",
    method: "GET",
    name: "HoldedGet",
    description: "4free",
    type: "Holded",
    image: Holded,
    data: [
      {
        type: "type 1",
        required: true,
        description: "Description Variable 1",
        title: "Title Variable 1",
      },
      {
        type: "type 2",
        required: true,
        description: "Description Variable 2",
        title: "Title Variable 2",
      },
      {
        type: "type 3",
        required: true,
        description: "Description Variable 3",
        title: "Title Variable 3",
      },
      {
        type: "type 4",
        required: true,
        description: "Description Variable 4",
        title: "Title Variable 4",
      },
    ],
  },
  {
    endpoint: "url1/url2",
    method: "PUT",
    name: "HoldedPut",
    description: "4free",
    type: "Holded",
    image: Holded,
    data: [
      {
        type: "type 1",
        required: true,
        description: "Description Variable 1",
        title: "Title Variable 1",
      },
      {
        type: "type 2",
        required: true,
        description: "Description Variable 2",
        title: "Title Variable 2",
      },
      {
        type: "type 3",
        required: true,
        description: "Description Variable 3",
        title: "Title Variable 3",
      },
      {
        type: "type 4",
        required: true,
        description: "Description Variable 4",
        title: "Title Variable 4",
      },
    ],
  },
  {
    endpoint: "url1/url2",
    method: "PATCH",
    name: "HoldedPatch",
    description: "4free",
    type: "Holded",
    image: Holded,
    data: [
      {
        type: "type 1",
        required: true,
        description: "Description Variable 1",
        title: "Title Variable 1",
      },
      {
        type: "type 2",
        required: true,
        description: "Description Variable 2",
        title: "Title Variable 2",
      },
      {
        type: "type 3",
        required: true,
        description: "Description Variable 3",
        title: "Title Variable 3",
      },
      {
        type: "type 4",
        required: true,
        description: "Description Variable 4",
        title: "Title Variable 4",
      },
    ],
  },
  {
    endpoint: "url1/url2",
    method: "DELETE",
    name: "HoldedDelete",
    description: "4free",
    type: "Holded",
    image: Holded,
    data: [
      {
        type: "type 1",
        required: true,
        description: "Description Variable 1",
        title: "Title Variable 1",
      },
      {
        type: "type 2",
        required: true,
        description: "Description Variable 2",
        title: "Title Variable 2",
      },
      {
        type: "type 3",
        required: true,
        description: "Description Variable 3",
        title: "Title Variable 3",
      },
      {
        type: "type 4",
        required: true,
        description: "Description Variable 4",
        title: "Title Variable 4",
      },
    ],
  },
];
